import type { FaireProductEntity } from "../../entity_types/product";

export const p_8psz4h9x54: FaireProductEntity = {
  token: "p_8psz4h9x54",
  type: "product",
  name: "Arrabbiata Marinara Pasta Sauce",
  brandToken: "b_cswuxgoe1w",
  brandName: "Bona Furtuna",
  imageUrl: "https://cdn.faire.com/fastly/f25e73fc0b833932aae8ef0f8325e30efdb0df5b802ee51dc4121a675d0dc825.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c68981e095a9ba2f709d1974b15b628add573e2e6fb8373e4f1a0bda16cc842c.jpeg",
    "https://cdn.faire.com/fastly/b9716d71a6e4c3c02e088e14e7eb4503496e5447f8780b5ba74080ac722b262d.jpeg",
    "https://cdn.faire.com/fastly/4dfb9654309cdb9bb58cab5bdc853351ab0ba2869be6b201e22d4787e74b4dfe.jpeg",
    "https://cdn.faire.com/fastly/d48402d514021b9b28d6e678504c9f5c6011597c84b61ad4ef22a8078fd53467.jpeg",
    "https://cdn.faire.com/fastly/fba50ebd0a73471ae62e09d7e7e30ef34169026db252f436d7b57b954866e568.jpeg"
  ],
  priceDollars: 6.48,
  description: "Made with Corleonese heirloom tomatoes, each jar of our 100% organic Arrabbiata Marinara Pasta Sauce blends authentic Sicilian marinara and handpicked, air-dried Sicilian chili peppers from La Furtuna Estate.",
  tags: [],
  msrpDollars: 12.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:22.257Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
